import { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';
import type { CombatLogEntry } from '@/engine/combat';
import { cn } from '@/utils/cn';

export function CombatLog({ entries }: { entries: CombatLogEntry[] }) {
  const ref = useRef<HTMLUListElement>(null);

  useEffect(() => {
    if (ref.current) ref.current.scrollTop = ref.current.scrollHeight;
  }, [entries.length]);

  return (
    <ul
      ref={ref}
      className="h-full scroll-y space-y-1.5 rounded border border-ash-800 bg-ash-950/60 p-3 fluid-xs"
    >
      {entries.map((e) => (
        <motion.li
          key={e.id}
          initial={{ opacity: 0, x: e.actor === 'player' ? -6 : 6 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.25 }}
          className={cn(
            'font-ui leading-snug',
            e.actor === 'player' ? 'text-moss-300' : 'text-ember-300',
          )}
        >
          <span className="text-ash-500 uppercase tracking-widest mr-1">R{e.ronda}</span>
          <span className="font-semibold">{e.accion}:</span>{' '}
          <span className="text-ash-200">{e.resultado}</span>
          {e.roll && (
            <span className="ml-1 text-ash-500 tabular-nums">
              [d20={e.roll.tirada}+{e.roll.modificador}={e.roll.total}
              {e.roll.crit === 'hit' ? ' CRIT' : e.roll.crit === 'miss' ? ' PIFIA' : ''}]
            </span>
          )}
        </motion.li>
      ))}
    </ul>
  );
}
